import type { PF2eSourceBook } from '../api/client';
import { canonicalizeSourceBook, formatSourceWithPage } from './sourceBookTranslator';

type TranslateFn = (
  key: string,
  params?: Record<string, string | number>,
  defaultValue?: string,
) => string;

function sameText(left?: string | null, right?: string | null): boolean {
  return (left || '').trim().toLowerCase() === (right || '').trim().toLowerCase();
}

export function findSourceBook(books: PF2eSourceBook[], sourceBook: string | null | undefined): PF2eSourceBook | null {
  const canonical = canonicalizeSourceBook(sourceBook);
  if (!canonical) return null;
  return books.find(book => sameText(canonicalizeSourceBook(book.name), canonical)) || null;
}

export function localizedSourceBookName(
  book: PF2eSourceBook | null,
  sourceBook: string | null | undefined,
  language: string,
): string {
  const english = book?.name || canonicalizeSourceBook(sourceBook);
  const localized = book?.localized_name?.trim();
  if (language !== 'en' && localized && !sameText(localized, english)) {
    return `${localized} (${english})`;
  }
  return localized || english;
}

export function formatLocalizedSourceWithPage(
  sourceBook: string | null | undefined,
  sourcePg: string | number | null | undefined,
  t: TranslateFn,
  books: PF2eSourceBook[],
  language: string,
): string {
  const book = findSourceBook(books, sourceBook);
  const title = localizedSourceBookName(book, sourceBook, language);
  if (!title) return formatSourceWithPage(sourceBook, sourcePg, t);
  const page = sourcePg !== null && sourcePg !== undefined && sourcePg !== ''
    ? `${t('character_creation.pageIndicator', {}, 'pg.')} ${sourcePg}`
    : '';
  return [title, page].filter(Boolean).join(' · ');
}
